module.exports = __webpack_public_path__ + "img/offline-api-development.6a085d69.webp";